<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <luma-empty>
    <b-card>
      <b-btn variant="outline-success"
             class="float-right col-12"
             :to="{name: 'domain-create'}">
        Domain bestellen
      </b-btn>
    </b-card>
    <b-card>
      <luma-table url="domain/domains"
                  :columns="columns"
                  :model="domain"
                  :order="order"
                  :custom-filter="customFilter" >
        <template v-slot:actions="slotProps">
          <b-button variant="white small"
                    size="xs"
                    :to="{name: 'domain-details', params: { name: slotProps.item.name }}">
            Ansehen
          </b-button>
        </template>
      </luma-table>
    </b-card>
  </luma-empty>
</template>

<script>
  import LumaEmpty from "@/layout/LumaEmpty"
  import LumaDatatable from "@/components/LumaDatatable"
  import Domain from "@/store/models/domain/domain"

  export default {
    name: "domain-list-view",
    components: {
      LumaEmpty,
      'luma-table': LumaDatatable
    },
    data: () => ({
      columns: [
        {
          key: 'name',
          column: 'name',
          filter: true,
          order: true
        },
        {
          key: 'status',
          column: 'status',
          filter: true,
          order: true
        },
        {
          key: 'create',
          column: 'create',
          filter: true,
          order: true
        },
        {
          key: 'expire',
          column: 'expire',
          filter: true,
          order: true
        },
        {
          key: 'updated_at',
          column: 'updated_at',
          filter: true,
          order: true
        },
        {
          key: 'user',
          column: 'user',
          filter: true,
          order: true
        },
        {
          key: 'actions',
          column: 'actions',
          filter: false,
          order: false,
          slot: true
        }
      ],
      order: {
        'create': 'desc'
      },
      domain: Domain,
      customFilter: {
        connector: 'AND',
        fields: [
          {
            key: 'suspended_at',
            operator: 'IS NULL',
            value: ''
          }
        ]
      }
    })
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/domain/list_domain/DomainListView.vue